module.exports = __webpack_public_path__ + "img/收银系统-带屏幕.620eb954.png";